import { ImportJob } from 'entities/consentImport';
import { Selectors as Router } from 'router';
import { Selectors as SiteSelectors } from 'sections/client-management/services/sites';
import { kotlinRestAPIClient } from 'services/apiGatewayClient';
import { State } from 'store';
import { createService } from '../genericAPIGatewayService';
import { Service } from './services';

const client = kotlinRestAPIClient<ImportJob>();

const endpointCreator = (state: State) => {
  const siteId = Router.getSiteId(state);
  const site = SiteSelectors.getEntity(state, siteId);
  return siteId && site && site.brandId ? `/brands/${site.brandId}/consent_imports` : undefined;
};

export const { Actions, Selectors, Sagas } = createService<ImportJob, Service.JobByBrand>({
  service: Service.JobByBrand,
  client,
  endpointCreator,
  stateConverter: (state: State) => state.data.consentImportJobsByBrand,
  sagas: ['GET_COLLECTION'],
});
